import { useState, useEffect, useMemo } from "react"
import {
  InputGroup,
  InputLeftElement,
  Input,
  Divider,
  VStack,
  Box,
  Checkbox,
  Wrap,
  WrapItem,
  Tag,
  HStack,
  Text
} from "@chakra-ui/react";
import { SearchIcon, CloseIcon } from "@chakra-ui/icons";
import countryFlagEmoji from "country-flag-emoji";
import { CustomPopover } from "../custom-popover";

interface Props {
  value: string[];
  onChange: (newValue: string[]) => void;
}

export function CountryFilter({ value, onChange }: Props) {
  const countries = useMemo(() => countryFlagEmoji.list.map(l => l.name), []);
  const [filteredCountries, setFilteredCountries] = useState<string[]>([...countries]);
  const [searchValue, setSearchValue] = useState<string>("");

  useEffect(() => {
    if (!countries || countries.length === 0) {
      return;
    }

    if (!searchValue) {
      setFilteredCountries([...countries]);
    } else {
      setFilteredCountries(
        countries.filter((i) =>
          i.toLowerCase().includes(searchValue.toLowerCase())
        )
      );
    }
  }, [searchValue]);

  return (
    <CustomPopover
      property="Country"
      value={value?.length === 0 ? "all" : value.length === 1 ? value[0] : value.length + " selected"}
      popoverBodyProps={{ p: 0, fontSize: "sm" }}
      popoverContentProps={{ borderRadius: "xl" }}
      isActive={value?.length > 0}
    >
      <InputGroup size="sm" mt="1">
        <InputLeftElement pointerEvents="none">
          <SearchIcon color="gray.300" />
        </InputLeftElement>
        <Input
          border="none"
          placeholder="Search country"
          _active={{ boxShadow: "none" }}
          _focus={{ boxShadow: "none" }}
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
        />
      </InputGroup>
      <Divider mt="1" mb="2" />
      <VStack
        overflowY="auto"
        maxH="80"
        className="noScrollBar"
        alignItems="flex-start"
        px="4"
        pb="2"
      >
        {filteredCountries.map((i) => (
          <Box>
            <Checkbox
              isChecked={value.includes(i)}
              onChange={(e) => {
                let newValues = [...value];
                if (e.target.checked) {
                  newValues.push(i);
                } else {
                  newValues = newValues.filter((v) => v !== i);
                }

                onChange(newValues);
              }}
            >
              {i}
            </Checkbox>
          </Box>
        ))}
      </VStack>
      <Divider />
      {value?.length > 0 ? (
        <Wrap p="3" spacing="2">
          {value.map((v) => (
            <WrapItem>
              <Tag size="sm" color="white" bg="#31C52E">
                <HStack>
                  <Text>{v}</Text>
                  <CloseIcon
                    h="2"
                    w="2"
                    cursor="pointer"
                    onClick={() => {
                      onChange([...value].filter((r) => r !== v));
                    }}
                  />
                </HStack>
              </Tag>
            </WrapItem>
          ))}
        </Wrap>
      ) : (
        <></>
      )}
    </CustomPopover>
  );
}
